import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoginResponse } from '../../models/login-response.model';
import { environment } from '../../../../environments/environment';
import { ApiResponse } from '../../models/api-response.model';
@Injectable({
  providedIn: 'root'
})
export class PortalAdminService {
  private readonly apiUrl = `${environment.apiGatewayBaseUrl}/api/PortalAdmins`;
  // private readonly apiUrl = `https://localhost:7206/api/PortalAdmins`;


  constructor(private http: HttpClient) { }

  getPortalAdmins(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }

  getApprovedPortalAdmins(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/approved`);
  }

  getPendingPortalAdmins(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/requests`);
  }

  reviewPortalAdminRequest(portalAdminId: number, action: 'Approved' | 'Rejected', reviewedBy: number): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(`${this.apiUrl}/${portalAdminId}/review`, { portalAdminId, action, reviewedBy });
  }

  createPortalAdmin(newAdmin: any): Observable<ApiResponse<boolean>> {
    return this.http.post<ApiResponse<boolean>>(this.apiUrl, newAdmin);
  }

  updatePortalAdmin(id: number, updatedAdmin: any): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/${id}`, updatedAdmin);
  }

  loginRequestOtp(loginData: {
    emailOrUserName: string;
    password?: string;
    pin?: string;
  }): Observable<ApiResponse<any>> {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/Login`, loginData, {
      responseType: 'text' as 'json'
    });
  }

  confirmOtp(payload: { emailOrUserName: string; otp: string }) {
    return this.http.post<LoginResponse>(`${this.apiUrl}/verify-login-otp`, payload);
  }

  requestPasswordReset(payload: { email: string; newPassword: string }) {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/request-password-reset`, payload);
  }

  confirmPasswordReset(payload: { email: string; otp: string }) {
    return this.http.post<ApiResponse<any>>(`${this.apiUrl}/confirm-password-reset`, payload, {
      responseType: 'text' as 'json'
    });
  }

  disablePortalAdmin(id: number): Observable<ApiResponse<boolean>> {
    return this.http.patch<ApiResponse<boolean>>(`${this.apiUrl}/${id}/status/${false}`, {});
  }

  enablePortalAdmin(id: number): Observable<ApiResponse<boolean>> {
    return this.http.patch<ApiResponse<boolean>>(`${this.apiUrl}/${id}/status/${true}`, {});
  }

}
